module.exports = __webpack_public_path__ + "img/ban.b941bee.svg";